import { appSelectors } from '@appStore/reducers/app'
// import { NoWorkingHoursContainer } from 'components/containers/noWorkingHoursContainer'
import isEmpty from 'lodash/isEmpty'
import { useAppSelector } from 'shared/hooks'

import { NoAuth } from './NoAuth/NoAuth'
import { NoInstalled } from './NoInstalled/NoInstalled'
import { NoLinkedIn } from './NoLinkedIn/NoLinkedIn'
import { NoTimezone } from './NoTimezone/NoTimezone'
import { NoWorkingHours } from './NoWorkingHours/NoWorkingHours'
export function AuthController() {
	const isInstalled = useAppSelector(appSelectors.isInstalled)

	const linkedProfile = useAppSelector(appSelectors.linkedProfile)
	const appProfile = useAppSelector(appSelectors.appProfile)

	if (!isInstalled) {
		return <NoInstalled />
	}

	const noTimeZone = linkedProfile && appProfile?.timezoneOffset === null
	if (noTimeZone) {
		return <NoTimezone />
	}

	const hasProfile = Boolean(appProfile && !isEmpty(appProfile))

	const noWorkingHours =
		linkedProfile &&
		hasProfile &&
		!isEmpty(linkedProfile) &&
		!appProfile!.workingHoursSet

	if (noWorkingHours) {
		return <NoWorkingHours />
	}

	const noLinkedin = hasProfile && linkedProfile === null

	if (noLinkedin) {
		return <NoLinkedIn />
	}

	return <NoAuth />
}
